module.exports = __webpack_public_path__ + "static/img/xq-1.7f82952.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xq-1.png
// module id = RL3Q
// module chunks = 1